export const quotationsActions = {

  "SET_QUOTATION": "SET_QUOTATION"
};